import React, {PropTypes} from "react";
import {Field, reduxForm, formValueSelector, change} from "redux-form";
import { connect } from 'react-redux';
import MenuItem from "material-ui/MenuItem";
import Menu from "material-ui/Menu";
import Constants from "../../../classes/constants";
import {AutoComplete as MUIAutoComplete} from "material-ui";
import {AutoComplete, DatePicker, SelectField, TextField} from "redux-form-material-ui";
const validate = values => {
  const errors = {};
  const requiredFields = ['location', 'payroll', 'vertical', 'department', 'subDepartment', 'lineOfBusiness', 'businessCategory', 'revenueStream'];
  requiredFields.forEach(field => {

    if (values[field] == null) {
      errors[field] = 'Required'
    }
  });
  console.log(values.location);
  if (values.emailId && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailId)) {
    errors.emailId = 'Invalid email address'
  }


  return errors


}

class ApplyExit extends React.Component {

  constructor(props) {
    super(props);
    this.state = ({reportingTo: null, errorText: "", errorText2: ""})
    this.handleLobChange = this.handleLobChange.bind(this);
    this.handleFunctionChange = this.handleFunctionChange.bind(this);
  }

  handleLobChange(event, index, value){
    this.props.dispatch(change('editEmployee','businessCategory',null));
    if(index === 'Services Classifieds' || index === 'Cars&Bikes Classifieds' || index === 'Goods Classifieds' || index === 'Jobs Classifieds' || index === 'Real Estate Classifieds' || index === 'Core Classifieds' || index === 'RR Digital Marketing'){
      index = 'Classifieds'
    }
    else if(index === 'AtHomeDiva' || index === 'Home Services' || index === 'Goods C2C' || index === 'Goods Assured' || index === 'Cars Transactions' || index === 'Bikes Transactions' || index === 'Jobs Flexi' || index === 'Brokerage Transactions' || index === 'Events'){
      index = 'Transactions'
    }
    else if(index === 'Quikr PG'){
      index = 'Managed Rentals'
    }
    else if(index === 'Corporate Central'){
      index = 'Corporate'
    }
    else{
      index = 'NA'
    }
    this.props.dispatch(change('editEmployee','revenueStream',index));
  }

  handleFunctionChange(event, index, value){
    if(index === 'Sales'){
      index = 'Sales : Sales - Others'
    }
    if(index === 'Operations'){
      index = 'Operations : Operations - Others'
    }
    if(index === 'Ad - Operations'){
      index = 'Ad Sales'
    }
    this.props.dispatch(change('editEmployee','erp_department',index));
  }

  componentDidMount() {
    if (this.props.employee != null || this.props.employee != undefined) {
      if (this.props.employee.reportingTo == null || this.props.employee.managerName == null)
        this.setState({errorText: "Select Reporting manager"})
    }
    console.log(46,this.props.employee);
  }

  componentWillReceiveProps(props) {

  }

  render() {
    let menu = Object.assign([], this.props.employees);
    menu.sort((a, b)=> {
      if (parseInt(a.employeeCode) > parseInt(b.employeeCode))
        return true;
    });
    menu = menu.map((node)=> {
      return {
        text: node.employeeCode + " " + node.name,
        value: (<Menu
            style={{padding: 0, margin: 0, color: 'black', fontSize: '14'}}
            primaryText={node.employeeCode}
            secondaryText={node.name}
          />
        ),
      }
    });
    const dataSource1 = menu;
    const {handleSubmit, reset} = this.props;
    return (

      <div className="col-xs-12" style={{padding: 0}}>

        <form onSubmit={handleSubmit(data => {
          let reportingTo, verticalHead;
          if (this.state.reportingTo == null)
            reportingTo = this.props.employee.reportingTo;
          else
            reportingTo = this.state.reportingTo;

          if (this.state.verticalHead == null)
            verticalHead = this.props.employee.verticalHead;
          else
            verticalHead = this.state.verticalHead;

          if (this.state.errorText == "" && this.state.errorText2 == "") {
            this.props.edit(data, reportingTo, verticalHead);
          }
          console.log(data, reportingTo);
          //this.props.applyExit(data);
        })}>

          <div className="col-xs-12" style={{fontSize: '14px', padding: 0}}>

            <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
              <thead>
                <tr>
                  <th cellPadding="0" colSpan="4">
                    <span
                      className="bold pull-left">{this.props.employee.employeeCode}&nbsp;&nbsp;{this.props.employee.name}</span>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td style={{align: 'left', width: '18%'}}>Email Id:</td>
                  <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_txtName" className="GenText">
                      <Field
                        name="emailId"
                        component={TextField}
                        autoOk={true}
                        textFieldStyle={{width: '100%'}}
                        defaultValue={null} // DatePicker requires an object,
                        //and redux-form defaults to ''
                        hintText="Official Email Id"
                      />
                    </span>
                  </td>

                  <td style={{align: 'left', width: '18%'}}>Location:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                      <Field
                        name="location"
                        hintText="All"
                        style={{width: '100%'}}
                        component={SelectField}
                      >
                        <MenuItem value={null} primaryText="&nbsp;" disabled={false} selected={true}/>
                        {this.props.constants.locations.map((location) => {
                          return (
                            <MenuItem value={location} primaryText={location}/>);
                        })}
                      </Field>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td style={{align: 'left'}}>Department:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="department"
                        component={AutoComplete}
                        openOnFocus={true}
                        filter={MUIAutoComplete.caseInsensitiveFilter}
                        dataSource={Constants.departments}
                        label="Department"
                      />
                    </span>
                  </td>

                  <td style={{align: 'left'}}>Sub Department:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="subDepartment"
                        hintText="Sub Department"
                        component={AutoComplete}
                        openOnFocus={true}
                        filter={MUIAutoComplete.caseInsensitiveFilter}
                        dataSource={Constants.subDepartments}
                        label="Sub Department"
                      />
                    </span>
                  </td>
                </tr>

                <tr>
                  <td style={{align: 'left'}}>Reporting Manager:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <MUIAutoComplete
                        errorText={this.state.errorText}
                        onNewRequest={(chosenRequest, index)=> {
                          if (index == -1) {
                            this.setState({errorText: "Select Reporting Manager"})
                            return;
                          }
                          let reportingTo = chosenRequest.text.split(' ')[0];
                          this.setState({reportingTo: reportingTo, errorText: ""});
                        }}
                        onBlur={(e)=> {
                          if (e.target.value.length == 0 || e.target.value == " ") {
                            this.setState({errorText: "Select Reporting Manager"});
                          }
                        }}
                        autoOk={true}
                        filter={MUIAutoComplete.caseInsensitiveFilter}
                        textFieldStyle={{width: '100%'}}
                        defaultValue={this.props.employee.reportingTo + " " + this.props.employee.managerName} // DatePicker requires an object,
                        dataSource={dataSource1}
                        maxSearchResults={20}
                        searchText={this.props.employee.managerName != null ? this.props.employee.reportingTo + " " + this.props.employee.managerName : ""}
                      />
                    </span>
                  </td>

                  <td style={{align: 'left'}}>Date of Joining:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                      <Field name="dateOfJoining"
                        component={DatePicker}
                        autoOk={true}
                        textFieldStyle={{width: '100%'}}
                        defaultValue={null}
                        hintText="Date of Joining"
                      />
                    </span>
                  </td>
                </tr>

                <tr>
                  <td style={{align: 'left'}}>Vertical Head:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <MUIAutoComplete
                        errorText={this.state.errorText2}
                        onNewRequest={(chosenRequest, index)=> {
                          if (index == -1) {
                            this.setState({errorText2: "Select Vertical Head"});
                            return;
                          }
                          let verticalHead = chosenRequest.text.split(' ')[0];
                          this.setState({verticalHead: verticalHead, errorText2: ""});
                        }}
                        onBlur={(e)=> {
                          if (e.target.value.length == 0 || e.target.value == " ") {
                            this.setState({errorText2: "Select Vertical Head"});
                          }
                        }}
                        autoOk={true}
                        filter={MUIAutoComplete.caseInsensitiveFilter}
                        textFieldStyle={{width: '100%'}}
                        defaultValue={this.props.employee.verticalHead + " " + this.props.employee.verticalHeadName} // DatePicker requires an object,
                        // and redux-form defaults to ''
                        dataSource={dataSource1}
                        maxSearchResults={20}
                        searchText={this.props.employee.verticalHeadName != null ? this.props.employee.verticalHead + " " + this.props.employee.verticalHeadName : ""}
                      />
                    </span>
                  </td>

                  <td style={{align: 'left'}}>Vertical:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="vertical"
                        hintText="All"
                        style={{width: '100%'}}
                        component={SelectField}
                      >
                        {this.props.constants.verticals.map((vertical) => {
                          return (
                            <MenuItem value={vertical} primaryText={vertical}/>);
                        })}
                      </Field>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td style={{align: 'left'}}>Designation:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                      <Field
                        name="designation"
                        hintText="Designation"
                        style={{width: '100%'}}
                        component={TextField}
                      />
                    </span>
                  </td>

                  <td style={{align: 'left'}}>Function:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="function"
                        hintText="All"
                        style={{width: '100%'}}
                        component={SelectField}
                        onChange={this.handleFunctionChange}
                      >
                        <MenuItem value={null} primaryText="&nbsp;" disabled={false} selected={true}/>
                        {Constants.functions.map((func) => {
                          return (
                            <MenuItem value={func} primaryText={func}/>);
                        })}
                      </Field>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td style={{align: 'left'}}>Department for ERP:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="erp_department"
                        hintText="ERP Department"
                        style={{width: '120%'}}
                        component={SelectField}
                      >
                        <MenuItem value={null} primaryText="&nbsp;" disabled={false} selected={true}/>
                        {Constants.erp_department.map((erp) => {
                          return (
                            <MenuItem value={erp} primaryText={erp}/>);
                        })}
                      </Field>
                    </span>
                  </td>
                  <td style={{align: 'left'}}>PersonnelType:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="personnelType"
                        hintText="PersonnelType"
                        component={SelectField}
                        label="PersonnelType"
                        defaultValue={this.props.employee.personnelType != null ? this.props.employee.personnelType : ""}
                      >
                        <MenuItem value={this.props.employee.personnelType} primaryText="&nbsp;" disabled={false} selected={true}/>
                        {Constants.personneltype.map((PersonnelType) => {
                            return (
                                <MenuItem value={PersonnelType} primaryText={PersonnelType}/>);
                        })}
                      </Field>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td style={{align: 'left'}}>Payroll:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="payroll"
                        hintText="Payroll"
                        component={SelectField}
                        label="Payroll"
                      >
                        <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                        {this.props.constants.payrolls.map((payroll) => {
                          return (
                            <MenuItem value={payroll} primaryText={payroll}/>);
                        })}
                      </Field>
                    </span>
                  </td>

                  <td style={{align: 'left'}}>HRBP:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="hrbp"
                        hintText="HRBP"
                        component={SelectField}
                        label="HRBP"
                      >
                        <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                        {Constants.hrbp.map((hrbp) => {
                          return (
                            <MenuItem value={hrbp.split(" ")[0]} primaryText={hrbp}/>);
                        })}
                      </Field>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td style={{align: 'left'}}>Office Location:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="officeName"
                        hintText="Office Location"
                        component={SelectField}
                        label="Office Location"
                        defaultValue={this.props.employee.officeName != null ? this.props.employee.officeName : ""}
                      >
                        <MenuItem value={null} primaryText="&nbsp;" disabled={true} selected={true}/>
                        {this.props.constants.officeLocations.map((officeLocation) => {
                          return (
                            <MenuItem value={officeLocation} primaryText={officeLocation}/>);
                        })}
                      </Field>
                    </span>
                  </td>

                    <td style={{align: 'left'}}>Category:</td>
                    <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                          name="category"
                          hintText="Category"
                          style={{width: '100%'}}
                          component={SelectField}
                      >
                        <MenuItem value={null} primaryText="&nbsp;" disabled={false} selected={true}/>
                          {Constants.category.map((cat) => {
                              return (
                                  <MenuItem value={cat} primaryText={cat}/>);
                          })}
                      </Field>
                    </span>
                    </td>
                </tr>

                <tr>
                  <td style={{align: 'left'}}>Line of Business :</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="lineOfBusiness"
                        component={AutoComplete}
                        openOnFocus={true}
                        filter={MUIAutoComplete.caseInsensitiveFilter}
                        dataSource={Constants.lineOfBusiness}
                        label="Line of Business"
                        onChange={this.handleLobChange}
                        menuStyle={{"maxHeight": "150px"}}
                      />
                    </span>
                  </td>

                  <td style={{align: 'left'}}>Business Category :</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                      <Field
                        name="businessCategory"
                        component={AutoComplete}
                        openOnFocus={true}
                        filter={MUIAutoComplete.caseInsensitiveFilter}
                        dataSource={Constants.businessCategory[this.props.lob] || []}
                        label="Business Category"
                      />
                    </span>
                  </td>
                </tr>

                <tr>
                  <td style={{align: 'left'}}>Remarks:</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                       <Field
                        name="remarks"
                        hintText="remarks"
                        multiLine={true}
                        component={TextField}
                        label="Remarks"
                      />
                    </span>
                  </td>

                  <td style={{align: 'left'}}>Revenue Stream</td>
                  <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                    <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                       <Field
                        name="revenueStream"
                        component={AutoComplete}
                        openOnFocus={true}
                        dataSource={Constants.revenueStream}
                        filter={MUIAutoComplete.caseInsensitiveFilter}
                        label="Revenue Stream"
                        menuStyle={{"maxHeight": "150px"}}
                      />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <br/>
            <div className="col-md-6">
              <button type="submit" style={{width: '50%', marginRight: '20px'}} className="btn btn-default">Save
              </button>
              <button type="button" onClick={this.props.close} style={{width: '40%'}}
                      className="btn btn-default btn-group-lg">Cancel
              </button>
            </div>

          </div>
        </form>
      </div>

    );
  }

}

ApplyExit.propTypes = {};


ApplyExit = reduxForm({
  form: 'editEmployee',
  validate
})(ApplyExit)

const selector = formValueSelector('editEmployee')
ApplyExit = connect(state=>{
  const lob = selector(state,'lineOfBusiness');
  return {
    lob
  }
})(ApplyExit)

export default ApplyExit;



/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/Forms/EditEmployee.js
 **/